<template>
    <div>
        <button class="swb-btn swb-btn-small mb5" @click="toSelectAsset()">添加行</button>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th width="150">资产编号</th>
                <th width="200">资产名称</th>
                <th>
                    <div class="clearfix">
                        <div style="display:flex;float: left;width: calc(100% - 40px);">
                            <div style="width: calc(100% - 160px); text-align: left;">组装件名称</div>
                            <div style="width: 120px;">组装件数量</div>
                            <div style="width: 40px;"></div>
                        </div>
                        <div style="width: 40px;float: right;" class="font-blue"></div>
                    </div>
                </th>
                <th width="80">操作</th>
            </tr>
            </thead>
            <tbody id="assetList" class="body">
            <tr class="row" v-for="assetInfo, index in assetList" v-if="assetList != null && assetList.length > 0">
                <td class="ellipsis font12" style="text-align: left;"><span :title="assetInfo.innerCode">{{assetInfo.innerCode}}</span></td>
                <td class="ellipsis font12" style="text-align: left;"><span :title="assetInfo.title">{{assetInfo.title}}</span></td>
                <td class="font12">
                    <div class="clearfix">
                        <div style="width: 40px;float: right;">
                            <i class="icon iconfont icon-add2" style="font-size: 20px;color: #0c64eb" @click="selectAsmblAcc(index)"></i>
                        </div>
                        <div style="display:flex;float: left;width: calc(100% - 40px);" v-for="asmblAcc, accIndex in assetInfo.shopAsmblAccIoRecList">
                            <div style="width: calc(100% - 160px); margin-top: 2px; text-align: left;">
                                <span class="ellipsis" :title="asmblAcc.title">{{asmblAcc.title}}</span></div>
                            <div style="width: 120px; margin-top: 2px;">
                                <el-input type="number" :min="0" v-model.number="asmblAcc.quantity" @change="quantityChange(index, accIndex)"></el-input>
                            </div>
                            <div style="width: 40px;">
                                <i class="icon iconfont icon-shanchu" style="font-size: 22px;color: #0c64eb" @click="doDeleteAsmblAcc(index, accIndex)"></i>
                            </div>
                        </div>
                    </div>
                </td>
                <td class="font12"><a class="swb-btn swb-btn-link" @click="doDeleteAsset(index)">移除</a></td>
            </tr>
            <tr class="row" v-else></tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { showDevcSelectDlg } from '../devc/selectDlg'
    import { showShopAsmblAccIoRecListForSelectDlg } from './dialog'

    import asmblAccApi from '../../api/asmblAcc'
    import goodsCategApi from '../../api/goodsCateg'

    export default{
        name: 'swb-asmbl-acc-rel-asset',
        desc: '组装件定义保存',
        props: {
            mgmtSmlAreaId: {
                type: Number,
                default: null
            },
            comId: {
                type: Number,
                default: null
            },
            comLevel: {
                type: Number,
                default: null
            },
            includeSubComs: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                assetList: []
            }
        },
        created: function () {
        },
        methods: {
            // 添加行，选择资产，在账的资产均可选择
            toSelectAsset: function () {
                let self = this;
                let assetList = self.assetList || [];
                let deviceXIds = assetList.pluck("id") || [];
                //
                let filter = {};
                filter.retailerComId = this.comId;
                filter.includeSubComs = this.includeSubComs;
                filter.assetType = getEnumInfoWith("assetType", "name", "CommonDevc").value;
                filter.locked = false;
                filter.fiscalLocked = false;
                filter.fiscalAcctFlag = 1;
                filter.asmblDone = false;
                let params = {
                    filter: filter,
                    devcBizClolumType: getEnumInfoWith("devcBizClolumType", "name", "DefDlg").name,   // 通用选择
                    initSelectIds: deviceXIds,
                    selectAll: true
                };
                showDevcSelectDlg(params, function (deviceList) {
                    deviceList = deviceList || [];
                    for(let i = 0; i < deviceList.length; i++) {
                        let deviceInfo = deviceList[i];
                        if(!deviceXIds.contains(deviceInfo.id)) {
                            assetList.push(deviceInfo);
                        } else {
                            continue;
                        }
                    }
                    self.assetList = Utils.merge([], assetList);
                });
            },
            // 移除资产
            doDeleteAsset: function (index) {
                let assetList = this.assetList || [];
                for(let i = 0; i < assetList.length; i++) {
                    if(i == index) {
                        assetList.splice(i, 1);
                        break;
                    }
                }
                this.assetList = Utils.merge([], assetList);
            },
            // 选择待用组装件
            selectAsmblAcc: function (index) {
                let self = this;
                let assetList = self.assetList || [];
                let asmblAccQuantityMap = {};
                for(let i = 0; i < assetList.length; i++) {
                    let asset = assetList[i];
                    let asmblAccs = asset.shopAsmblAccIoRecList || [];
                    for(let j = 0; j < asmblAccs.length; j++) {
                        let asmblAcc = asmblAccs[j];
                        let selectQuantity = asmblAccQuantityMap[asmblAcc.keyId] || 0;
                        selectQuantity = selectQuantity + parseInt(asmblAcc.quantity);
                        asmblAccQuantityMap[asmblAcc.keyId] = selectQuantity;
                    }
                }
                //
                let assetInfo = assetList[index];
                let asmblAccList = assetInfo.shopAsmblAccIoRecList || [];
                let asmblAccKeys = [];
                for(let i = 0; i < asmblAccList.length; i++) {
                    let asmblAcc = asmblAccList[i];
                    let asmblAccKey = asmblAcc.asmblDefId + '_' + asmblAcc.sellerId + '_' + asmblAcc.recvVoucherId + '_' + asmblAcc.recvVoucherItemId;
                    if(!asmblAccKeys.contains(asmblAccKey)) {
                        asmblAccKeys.push(asmblAccKey);
                    }
                }
                let params = {
                    comId: assetInfo.retailerBizUnitId,
                    checkBox: true,
                    selectIds: asmblAccKeys
                };
                showShopAsmblAccIoRecListForSelectDlg(params, function (asmblAccs, theDlg) {
                    theDlg.close();
                    asmblAccs = asmblAccs || [];
                    for(let i = 0; i < asmblAccs.length; i++) {
                        let asmblAcc = asmblAccs[i];
                        if(!asmblAccKeys.contains(asmblAcc.keyId)) {
                            asmblAcc.initQuantity = asmblAcc.quantity;
                            let selectQuantity = asmblAccQuantityMap[asmblAcc.keyId] || 0;
                            if(parseInt(selectQuantity) >= parseInt(asmblAcc.quantity)) {
                                asmblAcc.quantity = 0;
                            } else {
                                asmblAcc.quantity = parseInt(asmblAcc.quantity) - parseInt(selectQuantity);
                            }
                            asmblAccList.push(asmblAcc);
                            asmblAccQuantityMap[asmblAcc.keyId] = parseInt(selectQuantity) + asmblAcc.quantity;
                        }
                    }
                    assetInfo.shopAsmblAccIoRecList = Utils.merge([], asmblAccList);
                    self.assetList = Utils.merge([], assetList);
                });
            },
            // 移除组装件
            doDeleteAsmblAcc: function (assetIndex, accIndex) {
                let assetList = this.assetList || [];
                let assetInfo = assetList[assetIndex];
                let asmblAccList = assetInfo.shopAsmblAccIoRecList || [];
                for(let i = 0; i < asmblAccList.length; i++) {
                    if(i == accIndex) {
                        asmblAccList.splice(i, 1);
                        break;
                    }
                }
                assetInfo.shopAsmblAccIoRecList = Utils.merge([], asmblAccList);
                this.assetList = Utils.merge([], assetList);
            },
            // 组装件数量变化事件
            quantityChange: function (assetIndex, accIndex) {
                let assetList = this.assetList || [];
                let assetInfo = assetList[assetIndex];
                let asmblAccList = assetInfo.shopAsmblAccIoRecList || [];
                let asmblAccInfo = asmblAccList[accIndex];
                if(Utils.isNoB(asmblAccInfo.quantity)) {
                    asmblAccInfo.quantity = 0;
                    MsgBox.warning("组装件数量必须为大于0的整数！");
                    return;
                } else {
                    if(!Utils.isNaturalStr(asmblAccInfo.quantity)) {
                        asmblAccInfo.quantity = 0;
                        MsgBox.warning("组装件数量必须为大于0的整数！");
                        return;
                    }
                }
                let asmblAccQuantityMap = {};
                for(let i = 0; i < assetList.length; i++) {
                    let asset = assetList[i];
                    let asmblAccs = asset.shopAsmblAccIoRecList || [];
                    for(let j = 0; j < asmblAccs.length; j++) {
                        if(i != assetIndex || (i == assetIndex && j != accIndex)) {
                            let asmblAcc = asmblAccs[j];
                            let selectQuantity = asmblAccQuantityMap[asmblAcc.keyId] || 0;
                            selectQuantity = selectQuantity + parseInt(asmblAcc.quantity);
                            asmblAccQuantityMap[asmblAcc.keyId] = selectQuantity;
                        }
                    }
                }
                //
                let errFlag = false;
                let lastQuantity = 0;
                for(let i = 0; i < asmblAccList.length; i++) {
                    if(i == accIndex) {
                        let asmblAcc = asmblAccList[i];
                        let selectQuantity = asmblAccQuantityMap[asmblAcc.keyId] || 0;
                        if((parseInt(selectQuantity) + parseInt(asmblAcc.quantity)) > parseInt(asmblAcc.initQuantity)) {
                            asmblAcc.quantity = 0;
                            lastQuantity = (parseInt(asmblAcc.initQuantity) - parseInt(selectQuantity)) || 0;
                            errFlag = true;
                            break;
                        }
                    }
                }
                assetInfo.shopAsmblAccIoRecList = Utils.merge([], asmblAccList);
                this.assetList = Utils.merge([], assetList);
                if(errFlag) {
                    MsgBox.warning("该组装件数量最多还有[" + lastQuantity + "]个，请重新输入组装件数量或者选择其他组装件!");
                }
            },
            // 返回结果
            getDlgResult: function () {
                let assetList = this.assetList || [];
                if(assetList.length <= 0) {
                    MsgBox.warning("请添加行，选择要关联组装件的资产！");
                    return;
                }
                let errMsg = '';
                for(let i = 0; i < assetList.length; i++) {
                    let asset = assetList[i];
                    let asmblAccs = asset.shopAsmblAccIoRecList || [];
                    if(asmblAccs.length <= 0) {
                        errMsg = '请为资产[' + asset.innerCode + ']选择组装件，或者移除该资产';
                        break;
                    }
                    for(let j = 0; j < asmblAccs.length; j++) {
                        let asmblAcc = asmblAccs[j];
                        if(parseInt(asmblAcc.quantity) <= 0) {
                            errMsg = '请为资产[' + asset.innerCode + ']的组装件[' + asmblAcc.title + ']输入大于0数量';
                            break;
                        }
                    }
                    if(!Utils.isNoB(errMsg)) {
                        break;
                    }
                }
                if(!Utils.isNoB(errMsg)) {
                    MsgBox.warning(errMsg);
                    return;
                }
                //
                let result = {};
                result.type = "info";
                result.data = assetList;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asmblAcc/AsmblAccRelAsset.vue